function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isVNode, createVNode } from 'vue';
import '../components/index.mjs';
import { tryCall } from '../utils.mjs';
import TableV2HeaderRow from '../components/header-row.mjs';
function _isSlot(s) {
  return typeof s === "function" || Object.prototype.toString.call(s) === "[object Object]" && !isVNode(s);
}
const HeaderRenderer = (_ref, _ref2) => {
  let columns = _ref.columns,
    columnsStyles = _ref.columnsStyles,
    headerIndex = _ref.headerIndex,
    style = _ref.style,
    headerClass = _ref.headerClass,
    headerProps = _ref.headerProps,
    ns = _ref.ns;
  let slots = _ref2.slots;
  const param = {
    columns,
    headerIndex
  };
  const kls = [ns.e("header-row"), tryCall(headerClass, param, ""), {
    [ns.is("customized")]: Boolean(slots.header)
  }];
  const extraProps = _objectSpread(_objectSpread({}, tryCall(headerProps, param)), {}, {
    columnsStyles,
    class: kls,
    columns,
    headerIndex,
    style
  });
  return createVNode(TableV2HeaderRow, extraProps, _isSlot(slots) ? slots : {
    default: () => [slots]
  });
};
export { HeaderRenderer as default };